module.exports = __webpack_public_path__ + "static/img/institucional-marcas.d192c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institucional-marcas.png
// module id = l0t3
// module chunks = 1